/**
 * @generated SignedSource<<9096f60a71914e62cce761e5bd85c871>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProducSkuImageMobile_ProductSku$data = {
  readonly id: string;
  readonly name: string;
  readonly images: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly url: string;
        readonly urlFullSize: string;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"ProductSkuImagesGallery_ProductSkuImageConnection">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuHighlightedPromotion_ProductSku">;
  readonly " $fragmentType": "ProducSkuImageMobile_ProductSku";
};
export type ProducSkuImageMobile_ProductSku$key = {
  readonly " $data"?: ProducSkuImageMobile_ProductSku$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProducSkuImageMobile_ProductSku">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProducSkuImageMobile_ProductSku",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuImageConnection",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuImageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuImage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "size",
                      "value": 1000
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": "url(size:1000)"
                },
                {
                  "alias": "urlFullSize",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "size",
                      "value": 2000
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": "url(size:2000)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductSkuImagesGallery_ProductSkuImageConnection"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductSkuHighlightedPromotion_ProductSku"
    }
  ],
  "type": "ProductSku",
  "abstractKey": null
};
})();

(node as any).hash = "9c2c0ba7100a914635f3a909105da2cc";

export default node;
